import { useEffect, useState } from "react";
import InputForm from "../../atoms/InputForm";
import Button from "../../button/button";
import {
	contentStyle,
	defaultStyle,
	descriptionStyle,
	titleStyle,
	buttonStyle
} from "../Modal/style";
import { CSSTransition } from "react-transition-group";
import { css } from "emotion";
import { useNewOffer } from "../../../js/context/new-offer";

const Await2FAModal = ({ show, onConfirm, onCancel, onChange }) => {
	const { twoFactorData, setTwoFactorData } = useNewOffer();

	const [timeLeft, setTimeLeft] = useState(twoFactorData.modal.timeLeftInSeconds);

	useEffect(() => {
		let timer;

		if (show && timeLeft > 0) {
			timer = setInterval(() => {
				setTimeLeft(prevTime => prevTime - 1);
			}, 1000);
		}
		return () => clearInterval(timer);
	}, [show, timeLeft]);

	const formatTime = () => {
		const minutes = Math.floor(timeLeft / 60);
		const seconds = timeLeft % 60;
		return `${minutes}:${seconds.toString().padStart(2, "0")}`;
	};

	const handleCodeChange = event => {
		const { value } = event.target;
		setTwoFactorData(prevState => ({
			...prevState,
			code: value
		}));
	};

	return (
		<CSSTransition in={show} unmountOnExit timeout={1000}>
			<div
				className={`modal-two-factor-authentication ${css`
					${defaultStyle}
				`}`}
			>
				<div
					className={`extra-contentStyle ${css`
						${contentStyle}
					`}`}
				>
					<div
						className={css`
							${titleStyle}
						`}
					>
						{twoFactorData.modal?.title}
					</div>

					<div
						className={css`
							${descriptionStyle}
						`}
					>
						<div className="description">
							<p className="info">{twoFactorData.modal?.description}</p>
							<InputForm
								name="twoFactorCode"
								id="twoFactorCode"
								type="text"
								value={twoFactorData.code}
								onChange={handleCodeChange}
								label="Código de validação"
								maxLength={twoFactorData.modal.maxLength}
							/>
						</div>
					</div>

					<div
						className={`extra-buttonStyle ${css`
							${buttonStyle}
						`}`}
					>
						{timeLeft !== 0 ? (
							<div className="extra-info">
								<i className="icon-max-action-time" />
								<span>Aguarde até: {formatTime()}</span>
							</div>
						) : (
							<Button className="btn-gray-md-o" onClick={onCancel}>
								Não recebi o código
							</Button>
						)}
						<Button className="btn-primary-md" disabled={!twoFactorData.code} onClick={onConfirm}>
							Confirmar código
						</Button>
					</div>
				</div>
			</div>
		</CSSTransition>
	);
};

export default Await2FAModal;
